const FitType ={WIDTH:'width', HEIGHT:'height'};
export default FitType;